var _g, _g2, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopifyProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1035_7642)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_1035_7642)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1035_7642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13037 11.7218C10.6956 9.63485 12.7825 5.46094 21.6509 5.46094C29.0935 5.46094 33.7326 5.46094 39.3271 5.46094C44.9217 5.46094 49.4086 8.41746 50.9738 11.7218",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3157 20.4438C20.1601 20.5702 20.1279 20.754 20.0716 21.1602C19.9977 21.7028 18 37.112 18 37.112L34.7409 40.0002L41.9967 38.2009C41.9967 38.2009 39.0364 18.2351 39.0176 18.0981C38.9987 17.9611 38.8787 17.8851 38.7792 17.8768C38.6804 17.8686 36.7446 17.8392 36.7446 17.8392C36.7446 17.8392 35.1256 16.2709 34.9657 16.1114C34.8058 15.9518 34.4934 16 34.372 16.0361C34.3709 16.0367 34.2033 16.0884 33.9081 16.1796C33.8063 16.211 33.6893 16.2471 33.5588 16.2875C33.5573 16.2828 33.5559 16.2781 33.5544 16.2734L32.7177 16.537C32.7187 16.5401 32.7196 16.5432 32.7206 16.5463C32.4648 16.6252 32.1858 16.7114 31.8881 16.8034C31.7371 16.85 31.5814 16.8981 31.4215 16.9474C31.4215 16.9467 31.4215 16.946 31.4215 16.9453L20.3157 20.4438Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7824 17.8776C38.6836 17.8693 36.7478 17.84 36.7478 17.84C36.7478 17.84 35.1289 16.2717 34.969 16.1121C34.9094 16.0527 34.8287 16.0218 34.7441 16.009L34.7449 39.9995L42 38.2009C42 38.2009 39.0397 18.2358 39.0209 18.0989C39.002 17.9619 38.8813 17.8859 38.7824 17.8776Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7211 21.5996L29.8785 24.7444C29.8785 24.7444 28.9385 24.3178 27.8242 24.3877C26.1902 24.4909 26.1728 25.5188 26.1894 25.777C26.2785 27.1835 29.9878 27.4905 30.1961 30.7852C30.3598 33.3769 28.8177 35.1499 26.5961 35.2899C23.9292 35.4577 22.4612 33.8887 22.4612 33.8887L23.0262 31.4911C23.0262 31.4911 24.5041 32.6033 25.687 32.5288C26.4595 32.4799 26.7356 31.853 26.7077 31.4098C26.5915 29.5751 23.5709 29.6834 23.3801 26.6687C23.2193 24.1319 24.8896 21.5612 28.5748 21.3294C29.9946 21.2384 30.7211 21.5996 30.7211 21.5996Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1035_7642",
    x: 0,
    y: 2,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.594121 0 0 0 0 0.255313 0 0 0 0 0.7125 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1035_7642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1035_7642",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1035_7642",
    x: 4.73047,
    y: 0.960938,
    width: 50.6953,
    height: 15.0608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1035_7642"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_7642",
    x1: 30,
    y1: 4,
    x2: 30,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173913,
    stopColor: "#7DBA36",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DBA36"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopifyProducts);
export default __webpack_public_path__ + "static/media/shopify-products.1076fe343c409543d7bc92042bc55737.svg";
export { ForwardRef as ReactComponent };